import { Home, Wallet, Search, Route, User } from 'lucide-react'
import { useNavigate, useLocation } from 'react-router-dom'
import { useI18n } from '../i18n/useI18n'
import { isPlanEnabled } from '../lib/features'
import ActiveTableBanner from './ActiveTableBanner'

interface Tab {
  label: string
  icon: typeof Home
  path: string
}

// #1188 Phase 2: ウォレット独立タブ (PayPay/楽天ペイ 準拠、5 タブ構成)。
// #1277: スキャンタブ → 旅程(旅前プラン)タブ に置換。スキャンは店舗詳細「支払う」+
// ホーム「スキャンして支払う」から到達できるため、タブ専有をやめ旅前を第一級に。
const tabs: Tab[] = [
  { label: 'tab.home', icon: Home, path: '/home' },
  { label: 'tab.wallet', icon: Wallet, path: '/wallet' },
  { label: 'tab.explore', icon: Search, path: '/stores' },
  { label: 'tab.plan', icon: Route, path: '/plan' },
  { label: 'tab.profile', icon: User, path: '/profile' },
]

export default function TabBar() {
  const navigate = useNavigate()
  const location = useLocation()
  const { t } = useI18n()

  // #1774 PLAN_ENABLED=false の環境では /plan のルートごと消えるので、タブが残ると
  // **押しても catch-all でホームに戻るだけ**になる。導線ごと畳む。
  const visibleTabs = tabs.filter((tab) => tab.path !== '/plan' || isPlanEnabled())

  return (
    <>
      {/* #947 着席中セッションを home 等でも常時表示（支払いで消える） */}
      <ActiveTableBanner />
      <nav
        className="fixed bottom-0 left-1/2 -translate-x-1/2 w-full max-w-[430px] bg-white/95 backdrop-blur-md border-t border-gray-100 safe-bottom z-50"
        style={{ height: 83 }}
      >
      <div className="flex items-center justify-around h-[calc(83px-env(safe-area-inset-bottom,0px))]">
        {visibleTabs.map((tab) => {
          const isActive = location.pathname === tab.path
          const Icon = tab.icon

          return (
            <button
              key={tab.label}
              onClick={() => navigate(tab.path)}
              className="flex flex-col items-center justify-center gap-1 flex-1 h-full tap-effect"
            >
              <Icon
                size={24}
                className={
                  isActive
                    ? 'text-yokoso-red'
                    : 'text-text-tertiary'
                }
                strokeWidth={isActive ? 2.2 : 1.8}
              />
              <span
                className={`text-[12px] leading-none font-body ${
                  isActive
                    ? 'text-yokoso-red font-semibold'
                    : 'text-text-tertiary font-medium'
                }`}
              >
                {t(tab.label)}
              </span>
            </button>
          )
        })}
        </div>
      </nav>
    </>
  )
}
